{
  "version": 1,
  "asset_id": "ecb5ad02-50f5-4869-8992-8cc6d8e031d5",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/ecb5ad02-50f5-4869-8992-8cc6d8e031d5/battery-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/ecb5ad02-50f5-4869-8992-8cc6d8e031d5/battery-thumb.webp",
  "original_filename": "battery-thumb.webp",
  "size": 2392,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:24:39Z"
}
